export const feiche = {
  duringtype: [
    {
      value: 1,
      label: '一年期'
    }, {
      value: 2,
      label: '二年期'
    }, {
      value: 3,
      label: '三年期'
    }, {
      value: 4,
      label: '四年期'
    }, {
      value: 5,
      label: '五年期'
    }, {
      value: 6,
      label: '一个月'
    }, {
      value: 7,
      label: '二个月'
    }, {
      value: 8,
      label: '六个月'
    }
  ],
  feicheRole: [
    {
      value: 1,
      label: '投保人'
    }, {
      value: 2,
      label: '被保人'
    }, {
      value: 3,
      label: '车主'
    }
  ],
  clientType: [
    {
      value: '128',
      label: '个人'
    }, {
      value: '256',
      label: '企业'
    }
  ],
  UseProperty: [
    {
      value: '1',
      label: '家用'
    }, {
      value: '2',
      label: '非营业'
    }, {
      value: '3',
      label: '营业'
    }, {
      value: '9',
      label: '特种'
    }, {
      value: '10',
      label: '出租租赁'
    }, {
      value: '11',
      label: '城市公交'
    }, {
      value: '12',
      label: '公路客运'
    }
  ],
  premiumType: [
    {
      value: 1,
      label: '全保费计算'
    }, {
      value: 2,
      label: '净保费计算'
    }
  ],
  accountStatus: [
    {
      value: 0,
      label: '未结算'
    }, {
      value: 1,
      label: '部分结算'
    }, {
      value: 2,
      label: '已结算'
    }, {
      value: -4,
      label: '退保中'
    }, {
      value: 5,
      label: '结算中'
    }, {
      value: 8,
      label: '超额结算'
    }, {
      value: -8,
      label: '已退保'
    }
  ],
  feicheRemarkType: [
    {
      value: 1,
      label: '普通备注'
    }, {
      value: 2,
      label: '上游结算备注'
    }, {
      value: 3,
      label: '下游结算备注'
    }
  ],
  issueSource: [
    {
      value: 0,
      label: '自营'
    }, {
      value: 1,
      label: '第三方'
    }
  ],
  businessType: [
    {
      value: 2,
      label: '续保'
    }, {
      value: 256,
      label: '续保电网销'
    }, {
      value: 256,
      label: '续保电网销'
    }, {
      value: 4,
      label: '续保其他'
    }, {
      value: 1,
      label: '新保'
    }, {
      value: 32,
      label: '旧车首保'
    }
  ],
  periodtype: [
    {
      value: 1,
      label: '首期'
    }, {
      value: 2,
      label: '续期'
    }
  ],
  // 待提交、待审批、等待生效、生效中、已驳回、已过期、已停用
  policyStatus: [{
    value: 10,
    label: '待提交'
  }, {
    value: 11,
    label: '待审批'
  }, {
    value: 3,
    label: '等待生效'
  }, {
    value: 4,
    label: '生效中'
  }, {
    value: 12,
    label: '已驳回'
  }, {
    value: 5,
    label: '已过期'
  }, {
    value: 6,
    label: '已停用'
  }],
  orderPolicyStatus: [
    {
      value: 1,
      label: '生成中'
    }, {
      value: 2,
      label: '待生效'
    }, {
      value: 3,
      label: '已生效'
    }, {
      value: 4,
      label: '已失效'
    }, {
      value: 5,
      label: '已退保'
    }
  ],
  showPolicyStatus: [
    {
      value: 1,
      label: '正常'
      // }, {
      //   value: 2,
      //   label: '待确认'
    }
  ],
  periodDateType: [
    {
      value: 1,
      label: '签单日期'
    }, {
      value: 2,
      label: '支付日期'
    }
  ],
  priceTaxSeparated: [
    {
      value: 1,
      label: '价税分离'
    }, {
      value: 2,
      label: '价税不分离'
    }
  ],
  downstreamDimensionality: [
    {
      value: 1,
      label: '政策级别'
    }, {
      value: 2,
      label: '组织部门'
    }, {
      value: 3,
      label: '业务员'
    }
  ],
  RelationInsNoBi: [
    {
      value: 1,
      label: '否'
    }, {
      value: 2,
      label: '是'
    }
  ],
  InternetBusi: [
    {
      value: 1,
      label: '否'
    }, {
      value: 2,
      label: '是'
    }
  ],
  CorrectType: [
    {
      value: 1,
      label: '批增'
    }, {
      value: 2,
      label: '批减'
    }, {
      value: 3,
      label: '退保'
    }, {
      value: 4,
      label: '延期'
    }, {
      value: 5,
      label: '投保人'
    }, {
      value: 6,
      label: '被保人'
    }
  ],
  feicheBalanceType: [
    {
      value: 10010,
      label: '全费出单'
    }, {
      value: 10020,
      label: '净费出单'
    }
  ],
  IsTransferCar: [
    {
      value: 0,
      label: '未知'
    }, {
      value: 2,
      label: '是'
    }, {
      value: 1,
      label: '否'
    }
  ],
  companyType: [
    {
      value: 0,
      label: '%'
    }, {
      value: 1,
      label: '元'
    }
  ],
  businessWithCI: [
    {
      value: 1,
      label: '交商同保'
    }, {
      value: 10,
      label: '单商业'
    }, {
      value: 11,
      label: '单交强'
    }
  ],
  orderStatus: [
    {
      value: 1,
      label: '暂存'
    }, {
      value: 7,
      label: '核保中'
    }, {
      value: 2,
      label: '待支付'
    }, {
      value: 3,
      label: '已支付'
    }, {
      value: 4,
      label: '支付失败'
    }, {
      value: 5,
      label: '已关闭'
    }, {
      value: 6,
      label: '已取消'
    }, {
      value: 8,
      label: '拒保'
    }
  ],
  batchStatus: [{
    value: 2,
    label: '暂存'
  }, {
    value: 3,
    label: '待支付'
  }, {
    value: 4,
    label: '已支付'
  }, {
    value: 5,
    label: '已通过'
  }, {
    value: 6,
    label: '未通过'
  }, {
    value: 7,
    label: '已取消'
  }],
  payStatus: [
    {
      value: 0,
      label: '待支付'
    }, {
      value: 1,
      label: '支付结果查询中'
    }, {
      value: 2,
      label: '支付成功'
    }, {
      value: 3,
      label: '支付失败'
    }, {
      value: 4,
      label: '退款结果查询中'
    }, {
      value: 5,
      label: '退款成功'
    }, {
      value: 6,
      label: '退款失败'
    }
  ],
  channelSource: [
    {
      value: 1,
      label: 'APP'
    }, {
      value: 3,
      label: '小程序'
    }, {
      value: 5,
      label: '公众号'
    }, {
      value: 2,
      label: '网站'
    }, {
      value: 4,
      label: '其他渠道'
    }, {
      value: 6,
      label: '数据回传'
    }
  ],
  payMode: [
    {
      value: 1,
      label: '储蓄卡'
    }, {
      value: 2,
      label: '信用卡'
    }
  ],
  orderType: [
    {
      value: 1,
      label: '普通订单'
    }, {
      value: 2,
      label: '秒杀订单'
    }, {
      value: 3,
      label: '拼团订单'
    }, {
      value: 4,
      label: '其他订单'
    }
  ],
  relationship: [ // 被保人关系
    {
      label: '本人',
      value: 1
    }, {
      label: '配偶',
      value: 2
    }, {
      label: '父母',
      value: 3
    }, {
      label: '子女',
      value: 4
    }, {
      label: '其它',
      value: 99
    }
  ],
  insuredType: [
    {
      label: '基本医保',
      value: 1
    }, {
      label: '公费医疗',
      value: 2
    }, {
      label: '新市民',
      value: 3
    }, {
      label: '征地超转',
      value: 4
    }
  ],
  feicheIdentityType: [
    {
      label: '身份证',
      value: 11
    }, {
      label: '军官证',
      value: 14
    }, {
      label: '港澳居民往来内地通行证',
      value: 7
    }, {
      label: '台湾通行证',
      value: 8
    }, {
      label: '外国人护照',
      value: 2
    }, {
      label: '港澳台居民居住证',
      value: 18
    }, {
      label: '外国人永久居留证',
      value: 19
    }, {
      label: '统一社会信用代码',
      value: 30
    }, {
      label: '其它',
      value: 99
    }
  ],
  orderOperationType: [
    {
      value: 'System',
      label: '系统操作'
    }, {
      value: 'Click',
      label: '用户点击'
    }, {
      value: 'Input',
      label: '用户输入'
    }, {
      value: 'Refer',
      label: '用户查阅协议'
    }
  ],
  // 汇率设置
  exchangeList: [
    {
      value: 'CNY',
      label: '人民币-CNY'
    }, {
      value: 'USD',
      label: '美元-USD'
    }, {
      value: 'JPY',
      label: '日元-JPY'
    }, {
      value: 'HKD',
      label: '港币-KHD'
    }, {
      value: 'EUR',
      label: '欧元-EUR'
    }
  ],
  // 理赔状态
  claimStatus: [
    {
      value: '1',
      label: '出险'
    }, {
      value: '2',
      label: '查勘'
    }, {
      value: '3',
      label: '定损'
    }, {
      value: '4',
      label: '赔款'
    }, {
      value: '5',
      label: '结案'
    }
  ],
  // 附件类型
  attachmentType: [
    {
      value: '1',
      label: '电子保单'
    }, {
      value: '2',
      label: '身份证'
    }, {
      value: '3',
      label: '行驶证'
    }, {
      value: '4',
      label: '营业执照'
    }, {
      value: '5',
      label: '销售凭证（客户告知书，回执书，音视频等）'
    }
  ],
  // 批改类型
  correctTypeEnum: [{
    value: 'a',
    label: '加减人'
  }, {
    value: 'b',
    label: '整单退保'
  }, {
    value: 'c',
    label: '投保人'
  }, {
    value: 'd',
    label: '被保人'
  }, {
    value: 's',
    label: '标的'
  }],
  // 投保人类型
  applicantTypeEnum: [{
    value: '1',
    label: '个人'
  }, {
    value: '2',
    label: '团体'
  }],
  // 保单同步状态
  policyPushFlag: [{
    value: '0',
    label: '同步失败'
  }, {
    value: '1',
    label: '同步成功'
  }
  ],
  // 发票状态
  invoice: [{
    value: '0',
    label: '未申请'
  }, {
    value: '1',
    label: '申请中'
  }, {
    value: '2',
    label: '已开具'
  }
  ],
  // 抬头类型
  headType: [{
    value: '1',
    label: '个人/非企业'
  }, {
    value: '2',
    label: '企业单位'
  }
  ],
  // 加减人标识
  addTypeEnum: [{
    value: '1',
    label: '加人'
  }, {
    value: '2',
    label: '减人'
  }
  ],
  // 产销对接
  promotionEnum: [{
    value: '1',
    label: '是'
  }, {
    value: '0',
    label: '否'
  }
  ],
  // 险种类型
  insuranceTypeEnum: [{
    value: '10001',
    label: '机动车损失保险'
  }, {
    value: '10002',
    label: '机动车第三者责任保险'
  }, {
    value: '10003',
    label: '机动车全车盗抢保险'
  }, {
    value: '10004',
    label: '司机座位责任险'
  }, {
    value: '10005',
    label: '乘客座位责任险'
  }],
  monopolyType: [{
    label: '含指定送修码', value: '1'
  }, {
    label: '含任意送修码', value: '2'
  }, {
    label: '不含送修码', value: '3'
  }],
  busiTypeList: [{
    label: '随车险', value: 202
  }, {
    label: '财产险', value: 203
  }, {
    label: '人身险', value: 204
  }],
  refundType: [{
    label: '未退款',
    value: 0
  }, {
    label: '部分退款',
    value: 1
  }, {
    label: '全部退款',
    value: 2
  }]
}

export default {
  feiche
}



// WEBPACK FOOTER //
// ./src/data/feiche.js